//
//
//
//
//
//
//
//
//
//
//
//

import { loadGoogleMapsApi } from '@/utils/google/googleMapsLoader';

export default {
  name: 'GoogleMap',
  props: {
    initialZoom: {
      type: Number,
      default: 12
    }
  },
  data() {
    return {
      apiKey: '',
      initialCenter: {},
      map: null,
      google: null,
      marker: null,
      markerPosition: null,
      // markers: [],
      searchQuery: '',
      // searchResults: [],
      // placesService: null,
      currentCenter: {
        lng: 0,
        lat: 0
      }
    };
  },
  async mounted() {
    try {
      this.apiKey = process.env.VUE_APP_GOOGLE_MAP_APIKEY;

      if (!this.apiKey) {
        throw new Error('Google Maps API key is not set in environment variables.');
      }
      let position = await this.$utils.getCurrentPosition();
      console.log(process.env.VUE_APP_GOOGLE_MAP_APIKEY, position);
      this.initialCenter = { lat: position.latitude, lng: position.longitude };
      this.currentCenter = { ...this.initialCenter };

      // 加載Google Maps API，包含places庫
      this.google = await loadGoogleMapsApi(this.apiKey, ['places']);
      this.initMap();
    } catch (error) {
      console.error('Error loading Google Maps API:', error);
      this.$emit('error', error);
    }
  },
  methods: {
    initMap() {
      this.map = new this.google.maps.Map(this.$refs.map, {
        center: this.initialCenter,
        zoom: this.initialZoom,
        mapTypeControl: true,
        streetViewControl: true,
        fullscreenControl: true,
        styles: [
          {
            featureType: "poi",
            stylers: [{ visibility: "off" }]
          }
        ]
      });
      this.map.addListener('click', (event) => {
        this.placeMarker(event.latLng);
      });

      if (this.marker) {
        this.marker.setMap(null);
        this.marker = null;
      }
      this.markerPosition = null;

      this.bindInputAutocomplete();

    },
    placeMarker(location) {
      // 移除現有標記
      if (this.marker) {
        this.marker.setMap(null);
      }

      // 創建新標記
      this.marker = new google.maps.Marker({
        position: location,
        map: this.map,
        draggable: true,
        animation: google.maps.Animation.DROP,
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 10,
          fillColor: "#ea4335",
          fillOpacity: 1,
          strokeColor: "#ffffff",
          strokeWeight: 2
        }
      });

      // 保存位置
      this.markerPosition = {
        lat: location.lat(),
        lng: location.lng()
      };

      // 添加標記拖拽事件
      this.marker.addListener('dragend', (event) => {
        this.markerPosition = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng()
        };
      });

      //將地圖中心移動到標記位置
      this.map.panTo(location);

      this.currentCenter = {
        lat: this.markerPosition.lat,
        lng: this.markerPosition.lng
      };
      this.$emit('positionChange', this.markerPosition);
    },

    bindInputAutocomplete() {
      // 為搜索框創建自動完成功能
      var input = document.getElementById('search-input');
      var autocomplete = new google.maps.places.Autocomplete(input);
      autocomplete.bindTo('bounds', this.map);
      autocomplete.addListener('place_changed', () => {
        var place = autocomplete.getPlace();
        if (!place.geometry) {
          // 用戶輸入的地點無法解析
          window.alert("未找到地點: '" + place.name + "'");
          return;
        }

        // 如果地點有幾何信息，在地圖上顯示
        if (place.geometry.viewport) {
          this.map.fitBounds(place.geometry.viewport);
        } else {
          this.map.setCenter(place.geometry.location);
          this.map.setZoom(17); // 放大級別
        }

        this.placeMarker(place.geometry.location);
      });

      // 可選：添加手動搜索功能（當自動完成不生效時）
      function searchAddress() {
        var address = input.value;
        geocoder.geocode({ 'address': address }, function (results, status) {
          if (status === 'OK') {
            map.setCenter(results[0].geometry.location);
            this.placeMarker(results[0].geometry.location);
          } else {
            window.alert('地理編碼失敗，原因: ' + status);
          }
        });
      }

      // 回車鍵觸發搜索
      input.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
          searchAddress();
        }
      });
    }



    // initMap() {
    //   this.map = new this.google.maps.Map(this.$refs.map, {
    //     center: this.initialCenter,
    //     zoom: this.initialZoom,
    //     mapTypeControl: true,
    //     streetViewControl: true,
    //     fullscreenControl: true,
    //     styles: [
    //       {
    //         featureType: "poi",
    //         stylers: [{ visibility: "off" }]
    //       }
    //     ]
    //   });

    //   // 初始化地點服務
    //   this.placesService = new this.google.maps.places.PlacesService(this.map);

    //   // 監聽地圖中心變化
    //   this.map.addListener('center_changed', () => {
    //     const center = this.map.getCenter();
    //     this.currentCenter = {
    //       lat: center.lat(),
    //       lng: center.lng()
    //     };
    //   });

    //   // 添加初始標記
    //   this.addMarker(this.initialCenter);
    // },

    // addMarker(position = null) {
    //   if (!position) {
    //     // 在地圖中心添加標記
    //     position = this.map.getCenter();
    //   }

    //   const marker = new this.google.maps.Marker({
    //     position,
    //     map: this.map,
    //     title: `標記 ${this.markers.length + 1}`,
    //     draggable: true
    //   });

    //   // 添加資訊窗口
    //   const infoWindow = new this.google.maps.InfoWindow({
    //     content: `<div class="info-window">
    //         <h3>標記 ${this.markers.length + 1}</h3>
    //         <p>經度: ${position.lng.toFixed(6)}</p>
    //         <p>緯度: ${position.lat.toFixed(6)}</p>
    //       </div>`
    //   });

    //   marker.addListener('click', () => {
    //     infoWindow.open(this.map, marker);
    //   });

    //   this.markers.push(marker);
    // },

    // clearMarkers() {
    //   this.markers.forEach(marker => marker.setMap(null));
    //   this.markers = [];
    // },

    // centerMap() {
    //   this.map.setCenter(this.initialCenter);
    //   this.map.setZoom(this.initialZoom);
    // },

    // searchPlace() {
    //   if (!this.searchQuery.trim()) return;

    //   const request = {
    //     query: this.searchQuery,
    //     fields: ['name', 'geometry', 'formatted_address'],
    //     location: this.map.getCenter(),
    //     radius: 50000 // 50公裏半徑
    //   };

    //   this.placesService.textSearch(request, (results, status) => {
    //     if (status === this.google.maps.places.PlacesServiceStatus.OK) {
    //       this.searchResults = results.slice(0, 5);
    //     } else {
    //       this.searchResults = [];
    //       console.error('Places search failed:', status);
    //     }
    //   });
    // },

    // selectPlace(place) {
    //   this.searchResults = [];
    //   this.searchQuery = place.name;

    //   //移動地圖到選擇地點
    //   this.map.setCenter(place.geometry.location);
    //   this.map.setZoom(15);

    //   // 添加標記
    //   this.addMarker(place.geometry.location);
    // }
  }
};
